import { render, staticRenderFns } from "./zykh.vue?vue&type=template&id=1cb46cfa&"
import script from "./zykh.vue?vue&type=script&lang=js&"
export * from "./zykh.vue?vue&type=script&lang=js&"
import style0 from "./zykh.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports